import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import { PageLayout } from 'components/generics/PageLayout';
import { hasPemissions } from 'commons/utils';

import { TablePlanes } from './components/TablePlanes';
import { BannerInfoPlanes } from './components/BannerInfoPlanes';

export const PlanesIa = () => {
  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions(
      'modulo.manager',
      'modulo.manager.plataforma.ia',
      'create',
      'modulo.manager.plataforma.ia.comercial',
      'modulo.manager.plataforma.ia.comercial.planes'
    );
    setCanCreate(havePermissions);
  };

  return (
    <PageLayout
      title="Planes IA"
      mainModule="Plataforma IA"
      icon="CreditCard"
      infoAlert="Administración de planes comerciales de inteligencia artificial."
      actionButtons={
        <>
          {canCreate && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              component={Link}
              to={'/manager/plataforma-ia/comercial/planes/crear'}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)',
              }}
            >
              Crear Plan
            </Button>
          )}
        </>
      }
    >
      <TablePlanes />
      <BannerInfoPlanes />
    </PageLayout>
  );
};
